<div class="bg-light min-vh-100 d-flex flex-column align-items-center justify-content-center py-4">
  <c-container>
    <!-- Logo Section -->
    <c-row class="justify-content-center mb-4">
      <c-col xs="12" md="8" class="text-center">
        <a href="https://gooddogkh.com" target="_blank" rel="noopener">
          <!-- Added img-fluid and style for max-width -->
          <img
            src="assets/img/brand/cocopet-resort-long-900.png"
            title="Coco Pet Resort"
            class="img-fluid"
            style="max-width: 450px; width: 100%;"
          />
        </a>
      </c-col>
    </c-row>

    <!-- Main Card Section -->
    <c-row class="justify-content-center">
      <!-- Changed md="8" to lg="10" and xl="8" for better desktop scaling -->
      <c-col xs="12" lg="10" xl="8">
        <c-card-group>
          <!-- Login Card -->
          <c-card class="p-4">
            <c-card-body>
              <form cForm class="form" (ngSubmit)="login()" [formGroup]="loginForm" novalidate>
                <h1>Login</h1>
                <p class="text-medium-emphasis">Sign In to your account</p>

                <div *ngIf="error" class="alert alert-danger" role="alert">
                  {{ error }}
                </div>

                <c-input-group class="mb-3">
                  <span cInputGroupText>
                    <svg cIcon name="cilUser"></svg>
                  </span>
                  <input autoComplete="username" formControlName="username" class="form-control" placeholder="Username" />
                </c-input-group>

                <c-input-group class="mb-4">
                  <span cInputGroupText>
                    <svg cIcon name="cilLockLocked"></svg>
                  </span>
                  <input
                    autoComplete="current-password"
                    formControlName="password"
                    class="form-control"
                    placeholder="Password"
                    type="password"
                  />
                </c-input-group>

                <c-row>
                  <c-col xs="6">
                    <button cButton class="px-4" color="primary" type="submit" [disabled]="isLoading">
                      <c-spinner aria-hidden="true" size="sm" [hidden]="!isLoading"></c-spinner>
                      Login
                    </button>
                  </c-col>
                  <c-col class="text-end" xs="6"> <!-- Changed text-right to text-end for modern Bootstrap -->
                    <button cButton class="px-0" color="link">
                      Forgot password?
                    </button>
                  </c-col>
                </c-row>
              </form>
            </c-card-body>
          </c-card>

          <!-- Register/Info Card -->
          <!-- Removed fixed width percentage so it stacks on mobile -->
          <c-card class="text-white bg-primary py-5">
            <c-card-body class="text-center">
              <div>
                <h2>Sign up</h2>
                <p>Please sign up your pet in advanced.</p>
                <button [active]="true" cButton class="mt-3" color="primary" variant="outline" routerLink="/register-pet" style="border-color: white; color: white;">
                  Register Now!
                </button>
              </div>
              <div class="mt-5">
                <h2>Pick Up</h2>
                <p>Do you need pick up service? Book one now.</p>
                <button [active]="true" cButton class="mt-3" color="info" routerLink="/book-pick-up">
                  Book Now!
                </button>
              </div>
            </c-card-body>
          </c-card>
        </c-card-group>
      </c-col>
    </c-row>
  </c-container>
</div>
